import React from 'react';
import CybsSelect from '@cybs-ui/components/lib/select';
import {useSelector} from 'react-redux';
import { putDataInDevCenterDataStore } from '../../../app/store';
import { getHeaderCounter, getRequestHeaders } from '../../dynamic/reducers/rhs-schema-reducer';
import { getMethodType } from '../../../lhs/reducers/lhs-reducer';
import { getCredCookie } from '../../../commons/cookie';


const AuthTypeDropdown =(props) =>{

        var opts_length,opts=[],selectedItem;
        var authType = useSelector(state => state.lhsReducer.authorizationType)
        if(props.src==="Endpoint"){
            opts = [
            { value: 'HTTP Signature', label: 'HTTP Signature' },
            { value: 'Json Web Token', label: 'Json Web Token' },]
        }
        else{
            if(authType){
                opts_length = authType.length;
                var i;
                for(i=0; i<opts_length; i++){
                    opts.push({value: authType[i], label: authType[i] });
                }
            }
        }
        var currentAuthType = useSelector(state => state.configurationReducer.currentAuthType)
        if(!currentAuthType){
            selectedItem = opts[0];
        }
        else{
            if(!opts.length){
                selectedItem = {value: currentAuthType, label: currentAuthType};
            }
            else{
                var checkAuthTypePresent = false;
                for(var index in opts){
                    
                    if(opts[index].value == currentAuthType){
                        selectedItem = {value: currentAuthType, label: currentAuthType};
                        checkAuthTypePresent = true;
                        break;
                    }
                }
                if(!checkAuthTypePresent){
                    selectedItem = opts[0];
                    putDataInDevCenterDataStore({type: 'UPDATE_CURRENT_AUTH_TYPE', currentAuthType: opts[0].label});
               }
            }
        }
        const handleSelection = (event, selectedItem) => {
            putDataInDevCenterDataStore({type: 'UPDATE_CURRENT_AUTH_TYPE', currentAuthType: selectedItem[0].label});
            var headersMap = getRequestHeaders();
            if(selectedItem[0].label === 'Json Web Token'){
                if(headersMap){
                    delete headersMap['Digest']
                    delete headersMap['Date']
                    delete headersMap['Signature']
                    headersMap['v-c-merchantId'] = getCredCookie("jwtMerchantId");
                    headersMap['Authorization'] = "Send Request to Generate Bearer Token";
                }
            }
            else{
                if(headersMap){
                    delete headersMap['Authorization']
                    headersMap['v-c-merchantId'] = getCredCookie("merchantId");
                    headersMap['Date'] = "Send Request to Generate Date Value";
                    var methodType = getMethodType();
                    if(methodType == 'post' || methodType == 'patch' || methodType == 'put'){
                        headersMap['Digest'] = "Send Request to Generate Digest";
                    }
                    headersMap['Signature'] = "Send Request to Generate Signature"
                }
            }
            putDataInDevCenterDataStore({type:'UPDATE_REQUEST_HEADERS', requestHeaders:headersMap});
            var headerCounter = getHeaderCounter();
            if(headerCounter == undefined){
              putDataInDevCenterDataStore({type:'UPDATE_HEADER_COUNTER', headerCounter:0});
            }
            else{
              putDataInDevCenterDataStore({type:'UPDATE_HEADER_COUNTER', headerCounter:++headerCounter});
            }
            sessionStorage.setItem('currentAuthType', selectedItem[0].label)
        }
        return[
            <div className="auth-type-dropdown">
                <CybsSelect
                   dataTest="simple-dropdown"
                   i18n={{
                       label: "Authentication Type"
                   }}
                   items={opts}
                   selectedItems={[selectedItem]}
                   onSelect={handleSelection}
                   width="auto"
                />
            </div>
        ]

}


export default AuthTypeDropdown;